import { Star } from "lucide-react";
import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const stats = [
  { value: "5.0", lk: "rev_stat1", id: "google" },
  { value: "4.9", lk: "rev_stat2", id: "facebook" },
  { value: "2.6K+", lk: "rev_stat3", id: "followers" },
];

export default function Reviews({ compact = false }) {
  const { t } = useLang();
  const testimonials = t("testimonials");

  return (
    <section
      id="recensioni"
      data-testid="reviews-section"
      className={`${compact ? "py-14 md:py-20" : "py-24 md:py-32"} bg-[#4A5240] text-[#FAF9F6]`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#FAF9F6]/60 mb-4">
            {t("rev_overline")}
          </p>
        </Reveal>
        <div className="flex flex-col md:flex-row md:items-end gap-10 md:gap-20">
          <Reveal>
            <div className="flex items-start gap-4">
              <span
                data-testid="rating-big"
                className={`font-display ${compact ? "text-[5rem] md:text-[8rem]" : "text-[7rem] md:text-[11rem]"} leading-none font-medium`}
              >
                5.0
              </span>
              <div className={compact ? "pt-4 md:pt-8" : "pt-6 md:pt-12"}>
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={20}
                      className="fill-[#E8C468] text-[#E8C468]"
                    />
                  ))}
                </div>
                <p className="mt-3 text-sm text-[#FAF9F6]/70 max-w-[180px]">
                  {t("rev_caption")}
                </p>
              </div>
            </div>
          </Reveal>
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#FAF9F6]/20 border border-[#FAF9F6]/20">
            {stats.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.1} className="h-full">
                <div
                  data-testid={`stat-${s.id}`}
                  className={`bg-[#4A5240] ${compact ? "p-6" : "p-8"} h-full`}
                >
                  <p className="font-display text-4xl md:text-5xl font-medium">
                    {s.value}
                  </p>
                  <p className="mt-2 text-xs uppercase tracking-[0.15em] text-[#FAF9F6]/60">
                    {t(s.lk)}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.2}>
          <p className={`${compact ? "mt-8" : "mt-14"} text-base md:text-lg text-[#FAF9F6]/70 max-w-2xl`}>
            {t("rev_closing")}
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.25}>
        <div data-testid="reviews-marquee" className={`${compact ? "mt-10 pt-8" : "mt-16 pt-12"} border-t border-[#FAF9F6]/15`}>
          <Marquee speed={28} gradient={false} pauseOnHover>
            {testimonials.map((t, i) => (
              <figure
                key={i}
                data-testid={`review-card-${i}`}
                className="w-80 md:w-96 shrink-0 border border-[#FAF9F6]/15 rounded-2xl bg-[#FAF9F6]/5 p-7 mx-3 hover:bg-[#FAF9F6]/10 transition-colors duration-300"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} className="fill-[#E8C468] text-[#E8C468]" />
                  ))}
                </div>
                <blockquote className="font-display text-lg font-medium leading-snug">
                  "{t.text}"
                </blockquote>
                <figcaption className="mt-4 text-xs uppercase tracking-[0.2em] text-[#FAF9F6]/50">
                  {t.name}
                </figcaption>
              </figure>
            ))}
          </Marquee>
        </div>
      </Reveal>
    </section>
  );
}
